/**
 * Browser-side pairing store. The payload PARSER is shared verbatim with the MCP server
 * (`@shared/pairing-payload`, platform-neutral) — no port, no drift. This module adds only the
 * browser-specific bit: persisting the mirrored pairings (the `pairingSecret` is the E2E content key and
 * lives ONLY here, never at the backend).
 */
import { decodePairingPayload, type PairingPayload } from "@shared/pairing-payload";

export { decodePairingPayload };
export type { PairingPayload };

const STORAGE_KEY = "failover.pairings.v1";

export function loadPairings(): PairingPayload[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PairingPayload[]) : [];
  } catch {
    return [];
  }
}

function savePairings(pairings: PairingPayload[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pairings));
}

/** Add or replace a pairing by id (dedupe on pairingId). Returns the updated list. */
export function addPairing(p: PairingPayload): PairingPayload[] {
  const list = loadPairings().filter((x) => x.pairingId !== p.pairingId);
  list.push(p);
  savePairings(list);
  return list;
}

export function removePairing(pairingId: string): PairingPayload[] {
  const list = loadPairings().filter((x) => x.pairingId !== pairingId);
  savePairings(list);
  return list;
}
